import { navigate } from 'gatsby'

const availabilitySubmit = async ({ location }) => {
  const state = location?.state?.abbreviation?.toLowerCase()
  const city = location?.city?.toLowerCase()?.split(' ')?.join('-')
  navigate(`/${state}/${city}`)
}

export default availabilitySubmit
